import constantes from '../resources/constantes.json';
const getUrlResultados = (pairElectionAmbito, rutaAdicional, texto) => {
  try {
    const rutaAdicionalChequeada = rutaAdicional.includes('colombia')
      ? rutaAdicional
      : `/colombia/${rutaAdicional}`;
    const { ambito, eleccion } = pairElectionAmbito;
    const nombreEleccion = constantes.nomEleccionAmbitos[eleccion];
    let texto = '';
    window.zonaOComuna && (texto += `?zonaOComuna=${window.zonaOComuna}`);
    return `/${nombreEleccion}/${ambito.i}/${rutaAdicionalChequeada}${texto}`;
  } catch {
    return '';
  }
};

export default getUrlResultados;
